import { Table } from "react-bootstrap";

type TableDataProps = {
  info: {
    topic: string;
    subtopic: string;
    subgroup_messages: { [key: string]: string };
  };
  table: {
    variable_name: string;
    subgroup_name: string;
    variable_description: string;
    datasets: {
      dataset_title: string;
      association_text: string;
      associatoin_note_index: number | null;
    }[];
  }[];
  notes: { [key: string]: string };
};

export default function VariableConcordanceTable({ data }: { data: TableDataProps }) {
  const headers = ["VARIABLE", "DESCRIPTION", "DATASET"];

  return (
    <>
      <div className="alert alert-secondary" role="alert">
        <span className="fw-bold">{data.info.topic}</span> &gt; <span className="fw-bold">{data.info.subtopic}</span>
        <ul>
          {Object.entries(data.info.subgroup_messages).map(([key, value], index) => (
            <li key={index} className="mt-2">
              <strong>{key}:</strong> {value}
            </li>
          ))}
        </ul>
      </div>
      <Table className="vac-table">
        <thead>
          <tr className="vac-table-header-two">
            {headers.map((item: string, index: number) => (
              <th key={`header-${index}`} className="text-uppercase p-2 vac-table-study-col">
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.table.map((item, index) => (
            <tr key={`row-${index}`} className={index % 2 === 0 ? "table-striped-one" : "table-striped-two"}>
              <td>
                <span className="fw-bold d-block">{item.variable_name}</span>
                <span className="d-block">{item.subgroup_name}</span>
              </td>
              <td>{item.variable_description}</td>
              <td>
                {item.datasets.map((it, index) => (
                  <span className="d-block" key={index}>
                    <span>{it.dataset_title}</span> - <span>{it.association_text}</span>
                  </span>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {data["notes"] && (
        <div className="mt-4 px-1">
          {Object.keys(data["notes"]).map((key) => (
            <p className="mb-1" key={key}>
              <sup>{parseInt(key) + 1}</sup>
              {data["notes"][key]}
            </p>
          ))}
        </div>
      )}
    </>
  );
}
